<template>
  <transition name="fade">
    <div v-if="!closed" :class="wrapClasses">
      <slot v-if="showIcon" name="icon">
        <i :class="iconTypeClass"></i>
      </slot>
      <span :class="messageClasses"><slot></slot></span>
      <div v-if="desc" :class="descClasses">
        <slot name="desc"></slot>
      </div>
      <a v-if="closable" :class="closeClasses" @click="onACloseClick">
        <slot name="close">
          <i :class="$constants.ICON_CLOSE"></i>
        </slot>
      </a>
    </div>
  </transition>
</template>
<script>
import * as constants from '../../utils/constants'

const PREFIX_ALERT_CLASS = `${constants.PREFIX_CLASS}alert`

export default {
  props: {
    type: {
      type: String,
      validator(value) {
        return ['success', 'info', 'warning', 'danger', ''].includes(value)
      },
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      closed: false,
      desc: false
    }
  },
  computed: {
    wrapClasses() {
      return [
        `${PREFIX_ALERT_CLASS}`,
        {
          [`${PREFIX_ALERT_CLASS}--${this.type}`]: this.type,
          [`${PREFIX_ALERT_CLASS}--with-icon`]: this.showIcon,
          [`${PREFIX_ALERT_CLASS}--with-desc`]: this.desc
        }
      ]
    },
    messageClasses() {
      return `${PREFIX_ALERT_CLASS}__message`
    },
    descClasses() {
      return `${PREFIX_ALERT_CLASS}__desc`
    },
    closeClasses() {
      return `${PREFIX_ALERT_CLASS}__close-icon`
    },
    iconTypeClass() {
      let iconArr = [`${PREFIX_ALERT_CLASS}__icon`, constants.CLASS_MAIN]
      let type = ''

      switch (this.type) {
        case 'success':
          type = `${constants.PREFIX_ICON_CLASS}checkbox-marked-circle`
          break
        case 'info':
          type = `${constants.PREFIX_ICON_CLASS}information`
          break
        case 'warning':
          type = `${constants.PREFIX_ICON_CLASS}information`
          break
        case 'danger':
          type = `${constants.PREFIX_ICON_CLASS}close-circle`
          break
      }
      iconArr.push(type)
      return iconArr
    }
  },
  created() {
    this.desc = this.$slots.desc !== undefined
  },
  methods: {
    onACloseClick(e) {
      this.closed = true
      this.$emit('on-close', e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// alert.vue?73404edd